<template>
  <v-chip v-bind="$attrs" class="ts-player" :small="!big" :color="color || player.color" :dark="(player.meta && player.meta.dark) || true" @click="$emit('click')">
    <slot name="prepend"></slot>
    <slot>{{player.name}}</slot>
    <slot name="append"></slot>
  </v-chip>
</template>

<style>
  /* TsPlayer global */
  .ts-player{
    font-weight:bold;
    justify-content: center;
  }
</style>

<script>
  export default {
    name: "TsPlayer",
    props: {
      big: Boolean,
      color: String,
      player: {
        type: Object,
        default: () => ({name: 'name', color: 'grey', meta:{dark:true}})
      }
    },
  }
</script>